const ROUTE_MARKERS = [
  "/DefaultPage",
  "/Login",
  "/Register",
  "/ForgotPassword",
  "/MemberProfile",
  "/MemberCenter",
  "/OrderDetail",
  "/ResetPassword",
];

const normalizeBasePath = (value) => {
  if (!value || value === "/") return "";

  let normalized = value.trim();
  if (!normalized.startsWith("/")) {
    normalized = `/${normalized}`;
  }

  return normalized.replace(/\/+$/, "");
};

export const getAppBasePath = (pathname = window.location.pathname) => {
  const safePathname = pathname || "/";
  const normalizedPathname = safePathname.replace(/\/+$/, "") || "/";

  const markerIndexes = ROUTE_MARKERS.map((marker) =>
    normalizedPathname.indexOf(marker),
  ).filter((index) => index >= 0);

  if (markerIndexes.length > 0) {
    return normalizeBasePath(
      normalizedPathname.slice(0, Math.min(...markerIndexes)),
    );
  }

  if (normalizedPathname === "/") {
    return "";
  }

  return normalizeBasePath(process.env.PUBLIC_URL || "");
};

export const buildAppUrl = (
  appPath,
  origin = window.location.origin,
  pathname = window.location.pathname,
) => {
  const normalizedAppPath = appPath.startsWith("/") ? appPath : `/${appPath}`;
  return `${origin}${getAppBasePath(pathname)}${normalizedAppPath}`;
};
